<template>
  <el-dialog
    :appendToBody="true"
    title="删除目录"
    :visible.sync="dialogDeltreeVisible"
    width="470px"
    custom-class="qm-picture-library-delete-dialog"
  >
    <div class="del-tree-content">
      <div class="operating-instructions">
        <div
          class="del-tree"
          v-for="item in operationList"
          :key="item.type"
          :class="{
            'active': operationType == item.type,
            'del-tree-image': item.type == 1,
          }"
          @click.stop="selectTargetItem(item.type)"
        >
          <i class="qm-icon qm-icon-folder"></i>
          <span>{{ item.name }}</span>
          <span class="state-check" v-if="operationType == item.type">
            <i class="el-icon-check"></i>
          </span>
        </div>
      </div>
      <div class="qm-description" v-if="operationType == 1">
        <i class="qm-icon qm-icon-warn"></i>
        {{ delType === 1 ? '仅删除目录，图片自动移入默认目录' : '仅删除目录，视频自动移入根目录' }}
      </div>
    </div>
    <span slot="footer" class="del-tree-footer">
      <el-button @click="dialogDeltreeVisible = false">取 消</el-button>
      <el-button type="primary" @click="delTargetItem">删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    delType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      dialogDeltreeVisible: false,
      operationType: 1,
      explain: '仅删除目录，图片自动移入默认目录',
      operationList: [
        {
          name: '仅删除目录',
          type: 1,
        },
        {
          name: '删除目录及图片',
          type: 2,
        },
      ],
    }
  },
  watch: {
    delType: {
      handler(n) {
        if (n === 2) {
          this.operationList = [
            {
              name: '仅删除目录',
              type: 1,
            },
            {
              name: '删除目录及音视频',
              type: 2,
            },
          ]
        }
      },
      immediate: true,
    },
  },
  methods: {
    openDialog() {
      this.dialogDeltreeVisible = true
    },
    closeDialog() {
      this.dialogDeltreeVisible = false
    },
    // 选中目标项
    selectTargetItem(type) {
      this.operationType = type
    },
    delTargetItem() {
      this.$emit('delTargetItem', this.operationType)
    },
  },
}
</script>
